import { RootState } from "store";
import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { PAYMENT_CONFIG } from "constants/payment";

export const getUserDevices = (state: RootState) => state.userInfo;

export const getUserRole = (state: RootState) => state.userInfo.role;

export const getUserName = (state: RootState) => state.userInfo.username;

export const getUserInfo = (state: RootState) => state.userInfo;

export const getUserId = createDraftSafeSelector(
	getUserInfo,
	(state) => state.id
);

export const getTrialDaysRemaining = (state: RootState) =>
	state.userInfo.days_remaining_for_trial;

export const getUserEmail = (state: RootState) => state.userInfo.email;

export const getIsPayed = (state: RootState) => state.userInfo.is_payed;

export const getProctoringDisable = (state: RootState) => state.userInfo.proctoring_disable;

export const getProctoringPassed = (state: RootState) => state.userInfo.proctoring_passed;

export const getProctoringPassedAt = (state: RootState) => state.userInfo.proctoring_passed_at;

/** Цена школы из API (null, если бэк не вернул значение) */
export const getSchoolPrice = (state: RootState) => state.userInfo.school_price;

/**
 * Итоговая сумма для отображения:
 * берётся из school_price (API), иначе fallback на env (REACT_APP_PAYMENT_AMOUNT).
 * Fallback на env используется, например, для сборки Белбека.
 */
export const getPaymentAmount = (state: RootState) =>
	state.userInfo.school_price ?? PAYMENT_CONFIG.AMOUNT;

export const getTrialInfo = createDraftSafeSelector(
	getUserInfo,
	(state) => ({
		daysRemaining: state.days_remaining_for_trial,
		isPayed: state.is_payed,
	})
);
